import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Button, TextField, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';

const CreatePost = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const { schoolId } = useAuth();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const handleImagePick = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map(file => URL.createObjectURL(file));
    setImages(newImages);
  };

  const handleSubmit = async () => {
    if (!title || !description) {
      alert('Please fill in all required fields');
      return;
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('schoolId', schoolId);
    if (fileInputRef.current?.files) {
      Array.from(fileInputRef.current.files).forEach((file, index) => {
        formData.append('images', file);
      });
    }
    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/posts', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.status === 201) {
        alert('Post created successfully!');
        navigate('/school-interactions');
      }
    } catch (error) {
      console.error('Error creating post:', error);
      alert('Failed to create post. Please try again.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }} className="bg-gradient-to-b from-gray-100 to-gray-200">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 4, color: '#333' }}>
          Create Post
        </Typography>
        <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3 }}>
          <TextField
            fullWidth
            label="Title *"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            fullWidth
            label="Description *"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={4}
            sx={{ mb: 3 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => fileInputRef.current.click()}
            sx={{ mb: 3 }}
          >
            Add Images (Optional)
          </Button>
          <input
            type="file"
            accept="image/*"
            multiple
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleImagePick}
          />
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
            {images.map((uri, index) => (
              <img key={index} src={uri} alt="Preview" style={{ width: 100, height: 100, borderRadius: 8, objectFit: 'cover' }} />
            ))}
          </Box>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            sx={{ py: 2 }}
          >
            Post
          </Button>
        </Paper>
      </motion.div>
    </Container>
  );
};

export default CreatePost;